import { Component, ViewEncapsulation, Input, Output, EventEmitter } from '@angular/core';
import { TimeEvent } from '../time.provider';

@Component({
    selector: 'time-event-card',
    templateUrl: './event.card.html',
    styleUrls: ['./event.card.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class EventCard {

    @Input('timeEvent')
    event: TimeEvent = null;

    @Output('select')
    onSelect: EventEmitter<TimeEvent> = new EventEmitter<TimeEvent>();

    @Output('edit')
    onEdit: EventEmitter<TimeEvent> = new EventEmitter<TimeEvent>();

    showing: boolean = null;

    constructor() {
    }

    select(ev: TimeEvent) {
        this.onSelect.emit(ev);

        this.showing = (this.showing)? null : true;
    }

    edit(ev: TimeEvent) {
        if (ev && ev.id && this.onEdit.observers.length) {
            this.onEdit.emit(ev);
        }
    }

    Object = Object;

    isArray(obj: any): boolean {
        return Array.isArray(obj);
    }
}